import * as React from 'react'
import { GrRegex } from '../../../utilities/helpers'
import { IBaseProduct, INestedProduct } from '@getgreenline/homi-shared'
import { AsyncSearchInputWrapper } from './AsyncSearchInputWrapper'
import { CreateChildProduct } from '../../../containers/Dashboard/DashboardProducts/AddProduct/ProductStore'

// https://stackoverflow.com/questions/44321326/property-value-does-not-exist-on-type-eventtarget-in-typescript?rq=1
interface Props {
  value: string
  size?: 'small' | 'default' | 'large'
  disabled: boolean
  placeholder?: string
  style?: React.CSSProperties
  selectedChildProduct?: INestedProduct
  onChange: (value: string) => void
  searchDuplicateSkus: (searchQuery: string, products: IBaseProduct[]) => void
}

export class AsyncSKUSearchInput extends React.Component<Props> {
  filterProducts = (searchQuery: string, products: IBaseProduct[]): IBaseProduct[] => {
    const allProductsExceptCurrentProduct = products.filter((product) => {
      return product.id !== this.props.selectedChildProduct?.id
    })
    const matchingSKUProducts = allProductsExceptCurrentProduct.filter((product) => {
      // Return false if product.sku is null
      if (!product.sku) {
        return false
      }

      // Return true for similar sku
      const escapedSku = GrRegex.regEscape(searchQuery)
      const regexSku = new RegExp(escapedSku, 'ig')
      return product.sku.match(regexSku) !== null
    })

    // If sku doesn't exist in the input, remove all duplicate product list in the AddProduct component
    this.props.searchDuplicateSkus(searchQuery.trim(), matchingSKUProducts)

    return matchingSKUProducts
  }

  render() {
    const { value, size, placeholder, disabled } = this.props

    return (
      <AsyncSearchInputWrapper
        value={value}
        size={size}
        disabled={disabled}
        productId={null}
        placeholder={placeholder}
        filterProducts={this.filterProducts}
        onChange={this.props.onChange}
      />
    )
  }
}
